/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useMemo } from "react";

function CheckboxTableRow({ checkedItems, setCheckedItems, data, id }) {
  const hasId = useMemo(() => id !== undefined, [id]);

  const isChecked = useMemo(() => {
    return hasId
      ? checkedItems.some((i) => i === id)
      : data.length > 0 && checkedItems.length === data.length;
  }, [checkedItems]);

  const onCheckedRequest = ({ target: { checked } }) => {
    const hasId = id !== undefined;

    setCheckedItems((prev) => {
      let ret = [];
      if (checked) {
        ret = hasId ? [id, ...prev] : data.map((i) => i.id);
      } else if (hasId) {
        ret = prev.filter((i) => i !== id);
      }

      return ret;
    });
  };

  return (
    <label className="formLi">
      <input type="checkbox" className="chk" checked={isChecked} onChange={onCheckedRequest} />
      <span className="chkmrk"></span>
    </label>
  );
}

export default CheckboxTableRow;
